import React      from 'react';
import { Field }  from 'redux-form';
import classNames from 'classnames';

import BaseField from './base/BaseField';
import ErrorIcon from '../../icons/ErrorIcon';

export const RenderTextField = ({ ...props }) => (
  <Field
    component={TextFieldWrapper}
    type={'text'}
    {...props}
  />
);

const TextFieldWrapper = (props) => {
  const {
          input,
          label,
          required,
          meta: {
                  touched,
                  error,
                },
        } = props;
  return (
    <div
      className={classNames('field', {
        'empty': input.value === '',
        'error': touched && error,
      })}
    >
      <BaseField {...props} />
      <label>{label}{required && ' *'}</label>
      {touched && error && (<span className={'error'}><ErrorIcon />{error}</span>)}
    </div>
  );
};

RenderTextField.defaultProps = {
  required: false,
};